import { CONTRACT_FORM_SET_FEATURE, CONTRACT_FORM_SET_MCC } from '@engine/actions/action-types';
export var setContractFormFeature = function setContractFormFeature(feature) {
  return {
    type: CONTRACT_FORM_SET_FEATURE,
    payload: feature
  };
};
export var selectMerchantCategoryCode = function selectMerchantCategoryCode(merchantCategoryCode) {
  return {
    type: CONTRACT_FORM_SET_MCC,
    payload: merchantCategoryCode
  };
};